import React from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import "./ExtensionCreationFormInput.css";

const ExtensionCreationFormInput = ({ label, value, onChange, placeholder, type, error, helperText }) => {
    return (
        <div className="form-group">
            <label>{label} <span style={{ color: 'red' }}>*</span></label>
            {type === "text" ? (
                <InputText 
                    value={value} 
                    onChange={onChange} 
                    placeholder={placeholder} 
                    required 
                    className={`p-input-i ${error ? 'p-invalid' : ''}`} // Add error styling
                />
            ) : (
                <InputTextarea 
                    value={value} 
                    onChange={onChange} 
                    placeholder={placeholder} 
                    rows={3} 
                    required 
                    className={`p-textarea ${error ? 'p-invalid' : ''}`} // Add error styling
                />
            )}
            {error && <small className="p-error">{helperText}</small>} {/* Show error message */}
        </div>
    );
};

export default ExtensionCreationFormInput;
